import { FabricObject } from 'fabric';

import { OBJECT_ARTBOARD_KEY } from '../draw-canvas.constants';

export const isArtboard = (object: FabricObject) => {
  return OBJECT_ARTBOARD_KEY in object && object[OBJECT_ARTBOARD_KEY];
};
